import type { InvariantJiraRoute } from '@jira/platform__routing-route-types/src/InvariantJiraRoute.tsx';

export const projectSettingsServicedeskProactiveServiceManagementRoute: InvariantJiraRoute = {
	name: 'project-settings-servicedesk-proactive-service-management',
	path: '/jira/servicedesk/projects/:projectKey/settings/proactive-service-management',
	exact: true,
};
